
export default class Bridge {
	constructor(el) {
		this.el = el;
		this.callbacks = {};
		this.eventsObject = {};
	}

	createId() {
		let cbId = Math.round(Math.random() * 999999999);
		while (cbId in this.callbacks) {
			cbId = Math.round(Math.random() * 999999999);
		}
		return cbId;
	}

	createPromise(id, message) {
		return new Promise((resolve, reject) => {
			this.el.contentWindow.postMessage(message, '*');
      
			this.callbacks[id] = this.callbacks[id] || {};
			this.callbacks[id].resolve = resolve;
			this.callbacks[id].reject = reject;
		});
	}

	postMessage(params) {
		let id = '' + this.createId();
		let message = JSON.stringify({ api: params.api, data: params.data, id });
    
		this.callbacks[id] = this.callbacks[id] || {};
		this.callbacks[id].context = params.ctx;
		this.callbacks[id].promise = this.createPromise(id, message);

		return this.callbacks[id].promise;
	}

	getCallback(id, data) {
		let item = this.callbacks[id];
		item && item.resolve(data);
		delete this.callbacks[id];
	}
}

    


// WEBPACK FOOTER //
// ./components/bridge.js